var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// src/components/NewEditProcessModal.js
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress, Grid2 as Grid, } from '@mui/material';
import { createProcessoEdicao } from '../../services/processo-edicao.service';
import { formatCnpj } from '../../util/masks';
import { useDialog } from '../../hooks/useDialog';
export var NovoProcessoEdicaoModal = function (_a) {
    var processo = _a.processo, open = _a.open, onClose = _a.onClose;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var dialog = useDialog();
    var handleConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var processoEdicaoId, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (loading) {
                        return [2 /*return*/];
                    } // evita múltiplos disparos
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 6, 7]);
                    return [4 /*yield*/, createProcessoEdicao(processo.processoId)];
                case 2:
                    processoEdicaoId = _a.sent();
                    return [4 /*yield*/, dialog.alert({
                            title: 'Sucesso',
                            content: 'Processo de edição criado com sucesso!',
                            okText: 'Ir para a Edição',
                        })];
                case 3:
                    _a.sent();
                    onClose(processoEdicaoId);
                    return [3 /*break*/, 7];
                case 4:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [4 /*yield*/, dialog.alert({
                            title: 'Erro',
                            content: 'Erro ao criar processo de edição. Tente novamente.',
                            okText: 'Ok',
                        })];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        if (!loading) {
            onClose();
        }
    };
    return (_jsxs(Dialog, { open: open, onClose: handleClose, children: [_jsx(DialogTitle, { children: "Confirma\u00E7\u00E3o" }), _jsx(DialogContent, { dividers: true, children: loading ? (_jsx(Grid, { container: true, justifyContent: "center", alignItems: "center", sx: { py: 4 }, children: _jsx(CircularProgress, {}) })) : (_jsxs(_Fragment, { children: [_jsx(Typography, { gutterBottom: true, children: "Deseja criar um novo processo de edi\u00E7\u00E3o de dados?" }), _jsxs(Grid, { container: true, spacing: 1, children: [_jsxs(Grid, { size: { xs: 12 }, children: [_jsx(Typography, { variant: "subtitle2", children: "N\u00FAmero do Processo:" }), _jsx(Typography, { variant: "body2", children: processo.numeroProcesso })] }), _jsxs(Grid, { size: { xs: 12 }, children: [_jsx(Typography, { variant: "subtitle2", children: "Empresa:" }), _jsx(Typography, { variant: "body2", children: processo.empresaRazaoSocial })] }), _jsxs(Grid, { size: { xs: 12 }, children: [_jsx(Typography, { variant: "subtitle2", children: "CNPJ:" }), _jsx(Typography, { variant: "body2", children: formatCnpj(processo.empresaCnpj) })] }), _jsxs(Grid, { size: { xs: 12 }, children: [_jsx(Typography, { variant: "subtitle2", children: "Servi\u00E7o:" }), _jsx(Typography, { variant: "body2", children: processo.servicoCredenciamentoNome })] })] })] })) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: handleClose, disabled: loading, children: "Cancelar" }), _jsx(Button, { onClick: handleConfirm, variant: "contained", color: "primary", disabled: loading, children: "Confirmar" })] })] }));
};
